/* eslint-disable */
export default {
  infoMessageMins: 'Logboek automatisch opslaan over {delayTime} minuten...',
  infoMessageMin: 'Logboek automatisch opslaan over {delayTime} minuut...',
  infoMessageSecs: 'Logboek automatisch opslaan over {delayTime} seconden...',
  infoMessageSec: 'Logboek automatisch opslaan over {delayTime} seconde...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
